
<template>
    <form @submit.prevent="submit" class="position-relative">
        <span class="ic-exit position-absolute text-white cursor-pointer"
            @click.prevent="$eventHub.$emit('toggleOpenContactFormCheckout')"></span>
        <div class="cover">
            <img src="/img/pricing/contact-form-cover-logo.svg" alt="">
        </div>
        <div v-if="!submited" class="form-body">
            <h2>Contact Us</h2>
            <p>Please tell us a bit about your company and someone from our team will reach out.</p>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <input class="form-control"
                            type="text"
                            placeholder="Full Name *"
                            name="name"
                            id="name"
                            v-model="form.name">
                        <div v-if="errors && errors.name" class="text-danger">{{ errors.name}}</div>
                    </div>
                    <div class="form-group">
                        <input class="form-control"
                            type="text"
                            placeholder="Phone number"
                            name="phone"
                            id="phone"
                            v-model="form.phone">
                    </div>
                    <div class="form-group">
                        <div id="dropdown" class="dropdown">
                            <button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="form.industry.name === null" style="color: #989898;">
                                    Select Industy *
                                </span>
                                <span v-else>
                                    {{form.industry.name}}
                                </span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownButton">
                                <div
                                    v-for="industry in industries"
                                    :key="industry.id"
                                    @click="form.industry = industry"
                                    :class="{ 'active' : industry.id === form.industry.id }"
                                    class="dropdown-item">
                                    {{industry.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="errors && errors.industry" class="text-danger">{{ errors.industry}}</div>

                    </div>
                    <div class="form-group">
                        <div id="dropdown" class="dropdown">
                            <button type="button" id="dropdownButton" class="dropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="form.size.name === null" style="color: #989898;">
                                    Company Size *
                                </span>
                                <span v-else>
                                    {{form.size.name}}
                                </span>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownButton">
                                <div
                                    v-for="size in sizes"
                                    :key="size.id"
                                    @click="form.size = size"
                                    :class="{ 'active' : size.id === form.size.id }"
                                    class="dropdown-item">
                                    {{size.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="errors && errors.size" class="text-danger">{{ errors.size}}</div>

                    </div>


                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <input class="form-control"
                            type="email"
                            placeholder="Work Email *"
                            name="email"
                            id="email"
                            v-model="form.email">
                        <div v-if="errors && errors.email" class="text-danger">{{ errors.email}}</div>
                    </div>
                    <div class="form-group">
                        <input class="form-control"
                            type="text"
                            placeholder="Company Name *"
                            name="company"
                            id="company"
                            v-model="form.company">
                        <div v-if="errors && errors.company" class="text-danger">{{ errors.company }}</div>
                    </div>
                    <div class="form-group">
                        <input class="form-control"
                            type="text"
                            placeholder="Job Title *"
                            name="jobTitle"
                            id="jobTitle"
                            v-model="form.jobTitle">
                        <div v-if="errors && errors.jobTitle" class="text-danger">{{ errors.jobTitle }}</div>
                    </div>
                    <div class="form-group">
                        <input class="form-control"
                            type="text"
                            placeholder="Website URL"
                            name="website"
                            id="website"
                            v-model="form.website">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <textarea
                        id="message"
                        name="message"
                        rows="5"
                        class="form-control"
                        v-model="form.message"
                        placeholder="How can we help you? *"></textarea>
                    <div v-if="errors && errors.message" class="text-danger">{{ errors.message }}</div>
                </div>
            </div>

            <button class="send-btn cta-btn-v2 mb-0">
                <span v-if="loading">Submitting...</span>
                <span v-else>Contact Us</span>
            </button>
            <div v-if="tooMany" class="text-danger text-center mt-4">{{ tooMany }}</div>

            </div>
            <div v-if="submited" class="message message-content flex-column">
                <vue-calendly url="https://calendly.com/startinfinity/enterprise-solution?hide_gdpr_banner=1" class="calendly-widget"></vue-calendly>
            </div>
    </form>

</template>
<script>
import VueCalendly from 'vue-calendly';

Vue.use(VueCalendly);
import axios from 'axios';
export default {
    data() {
        return {
            form: {
                name: null,
                phone: null,
                message: null,
                email: null,
                company: null,
                jobTitle: null,
                website: null,
                size: {
                    id: null,
                    name: null,
                },
                industry: {
                    id: null,
                    name: null,
                },
            },
            errors: {},
            industries: [
                {
                    id:'64efcdad-b50b-4479-ad0e-2f762f642616',
                    name:'Marketing',
                },
                {
                    id:'a0effff1-fe8a-4fbc-aa74-e0bc6603fa34',
                    name:'Sales',
                },
                {
                    id:'6da24221-5b4d-4a92-a82a-ee1b70cd5fab',
                    name:'IT',
                },
                {
                    id:'06e82b9e-e712-4200-a969-6df9300f8f6c',
                    name:'Finance',
                },
                {
                    id:'82479963-465e-477b-9347-635c8c373fa8',
                    name:'Education',
                },
                {
                    id:'342f8fe1-4469-4111-8f7b-63cad8303630',
                    name:'Legal',
                },
                {
                    id:'128c31ac-8766-4b9c-aa1a-482327f3a682',
                    name:'HR',
                },
                {
                    id:'2685689e-1663-4bf1-b714-721ad2786b7f',
                    name:'Retail',
                },
                {
                    id:'6f9b88a2-61e7-4240-84bd-9a9895ee953f',
                    name:'Healthcare',
                },
                {
                    id:'69c0956c-156d-469c-aa4d-933643e1d7cc',
                    name:'Gaming',
                },
                {
                    id:'2cd03343-31f0-484b-9633-eee1e19964b1',
                    name:'Government',
                },
                {
                    id:'0ec76568-638e-44a0-8065-08ace3cef1e2',
                    name:'Art & Design',
                },
                {
                    id:'d4e1c506-6886-4b73-8ea9-239fd4f090fe',
                    name:'Tourism',
                },
                {
                    id:'9b9fb4a5-bbdb-4814-9e6f-ac46c14c37e9',
                    name:'Real Estate',
                },
                {
                    id:'510ce2c5-8e44-4cb8-9573-53e746abe3fc',
                    name:'Consumer Goods',
                },
                {
                    id:'5f2019de-568b-454f-a381-1caed76ec6d5',
                    name:'Non-Profit',
                },
                {
                    id:'07d2d208-cf65-41cc-b50a-963a3092dd0c',
                    name:'Other',
                }
            ],
            // sizes: ['1-20', '21-100', '101-250', '251-500', '501-1,000', '1,001-5,000', '5,000-10,000', '10,000-50,000', '50,000+'],
            sizes: [
                {
                    id:'77e6c114-28c9-401f-8d84-28d193daef6e',
                    name:'1-20',
                },
                {
                    id:'915524eb-d011-47b8-a10b-ae6054578b93',
                    name:'21-100',
                },
                {
                    id:'901d6455-91f0-49ef-9e15-276918701bed',
                    name:'101-250',
                },
                {
                    id:'ce2dd190-20f8-4966-b93e-ea511f984b27',
                    name:'251-500',
                },
                {
                    id:'34a0a63c-ffe6-4652-a616-be3fcbbf15ea',
                    name:'501-1000',
                },
                {
                    id:'6a5a65e5-b391-4c7b-88a0-76748a237c83',
                    name:'1001-5000',
                },
                {
                    id:'0e1605c4-ba46-4160-bf91-ca7b85720606',
                    name:'5000-10,000',
                },
                {
                    id:'3e7f4230-150c-4ab1-86c7-a8d8957618bf',
                    name:'10,000-50,000',
                },
                {
                    id:'46090cba-382a-45a3-80b3-6005d24b1f6a',
                    name:'50,000+',
                }
            ],
            submited:false,
            tooMany: null,
            loading: false
        };
    },
    mounted () {
        const recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
        document.head.appendChild(recaptchaScript);

        // CALENDLY EVENT LISTENER
        window.dataLayer = window.dataLayer ||[];
        window.addEventListener('message',
            function(e) {
                if (e.data.event && e.data.event.indexOf('calendly') === 0) {
                    window.dataLayer.push({
                        'event' : 'enterprise_calendly',
                        'calendly_event' : e.data.event.split('.')[1]
                    });
                }
            }
        );
    },
    methods: {
        submit() {
            this.errors = {};
            this.tooMany = null;
            if(this.form.name == null) {
                this.errors.name = 'Name is required';
            }
            if(this.form.email == null) {
                this.errors.email = 'Email is required';
            }
            if(this.form.company == null) {
                this.errors.company = 'Company Name is required';
            }
            if(this.form.jobTitle == null) {
                this.errors.jobTitle = 'Job Title is required';
            }
            if(this.form.message == null) {
                this.errors.message = 'Message is required';
            }
            if(this.form.industry.id == null) {
                this.errors.industry = 'Industry is required';
            }
            if(this.form.size.id == null) {
                this.errors.size = 'Company Size is required';
            }
            if(Object.keys(this.errors).length === 0) {
                this.loading = true;
                axios.post('/enterprise-contact-submit', this.form).then(() => {
                    this.loading = false;
                    this.submited=true;
                    dataLayer.push({
                        event: 'enterpriseFormSubmited',
                    });
                }).catch(error => {
                    if(error.response.status === 429) {
                        this.tooMany = error.response.data.message;
                    }
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                    }
                });
            }
        },
    },
};
</script>

<style scoped lang="less">
.calendly-widget {
    height: auto !important;
    margin-top: -40px;
    margin-bottom: 20px;
}
.dropdown {
    .dropdownButton {
        // appearance: none;
        width: 100%;
        height: 50px;
        border: 1px solid #DFDFDF;
        background-color: #fff;
        border-radius: 6px;
        color: #120C32;
        padding: 15px 18px;
        font-size: 16px;
        background-image: url('/img/pricing/dropdown-arrow-down.svg');
        background-repeat: no-repeat;
        background-size: 15px 9px;
        background-position: 95% 50%;
        text-align: left;
        display: flex;
        align-items: center;
        &:focus, &:active {
            border: 1px solid #BFB6FF;
            outline: none;
        }
    }
    .dropdown-menu {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        padding: 7px;
        height: 200px;
        max-height: 90vh;
        overflow-y: scroll;
        &::-webkit-scrollbar {
            border-radius: 10px;
            width: 8px;
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #62647b36;
        }
        .dropdown-item {
            cursor: pointer;
            border-radius: 6px;
            font-size: 16px;
            &:hover {
                background-color: #F6F4FF;
            }
        }
        .dropdown-item.active {
            background-color: transparent;
            color: #5946CF;
            background-image: url('/img/pricing/ic-check.svg');
            background-repeat: no-repeat;
            background-size: 15px 9px;
            background-position: 95% 50%;
            text-align: left;
        }
    }
}
form{
    margin:0 auto;
    border-radius: 20px;
    background-color: #FEFEFE;
    overflow: hidden;
    max-height: 95vh;
    width: 890px;
    max-width: 100%;
    @media screen and (max-width: 991px), 
        screen and (max-height: 950px) {
        overflow-y: scroll;
        &::-webkit-scrollbar {
            border-radius: 10px;
            width: 8px;
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #62647b36;
        }
    }

}
.form-body {
    padding: 30px 40px;
    @media(max-width: 768px) {
        padding: 30px 10px;
    }
}
.form-body h2 {
    font-size: 35px;
    line-height: 48px;
}
.form-body p {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
}
.cover {
    background-image: url(/img/pricing/contact-form-cover.png);
    background-size: cover;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.form-control::placeholder{
    color:#989898;
}
input[type="text"], input[type="email"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height:50px;
    outline:none;
    &:focus, &:active {
        border: 1px solid #BFB6FF;
        outline: none;
    }
}
textarea{
    height:120px;
    outline:none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    &:focus, &:active {
        border: 1px solid #BFB6FF;
        outline: none;
    }
}
select{
      height:50px;
  margin-bottom:30px;
  outline:none;
  color:#989898;
}
.form-control{
    border: 1px solid #DFDFDF;
    background: white;
    font-size: 16px;
    line-height: 19px;
    &:focus {
        box-shadow: unset;
    }
}
.form-group{
    margin-bottom:30px;
    outline: none;
}
.form-group:focus{
     outline: none;

}

.send-btn{
    cursor: pointer;
    border:none;
    height: 50px;
}
.send-btn:active{
    outline:none;
}
.send-btn:focus{
    outline:none;
}
.message{
    margin:0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px
}
.message-content{
    color:black;
}
.message-content p{
    font-size: 22px;
    line-height: 26px;
}
.message-content img{
    display: block;
    margin-bottom: 32px;
}


 </style>






// WEBPACK FOOTER //
// resources/js/frontend/components/EnterpriseContactForm.vue